import React from "react";

interface Props {
  activeColor: string;
}

const NewLeadIcon = ({ activeColor }: Props) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="24" cy="24" r="22" fill="#EDEBFA" />

      <path
        d="M17 16
         C15.5 17.5 15 19.5 16 22
         C17.5 25.5 22.5 30.5 26 32
         C28.5 33 30.5 32.5 32 31
         L29.5 28.5
         C29 28 28.2 27.8 27.6 28.1
         L25.5 29
         C24.5 29.4 23.4 29.2 22.6 28.4
         L19.6 25.4
         C18.8 24.6 18.6 23.5 19 22.5
         L19.9 20.4
         C20.2 19.8 20 19 19.5 18.5
         L17 16Z"
        stroke="#1E1B6A"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M30 16C33 18 34.5 21 34 24"
        stroke="#1E1B6A"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M28 18C30 19.5 31 21.5 30.8 23.5"
        stroke="#1E1B6A"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default NewLeadIcon;
